<script>
import { Alert } from '@zoom/zoom-ui';
import mxMonitor from '@/components/zoom-ui-plus/monitor-alert/mx-monitor.js';

export default {
  extends: Alert,
  mixins: [mxMonitor]
}
</script>
